/**
 * Mural adapter — per-type import adapter for 'mural' media type.
 *
 * Required columns (in addition to COMMON_REQUIRED_COLUMNS):
 * - '[Mural] Element 3D' (structurally required for mural rows)
 *
 * Optional type-specific columns:
 * - '[Mural] Tasma LED'
 * - '[Mural] Neon LED'
 * - '[Mural] Fluo UV'
 * - '[Mural] Produkcja eco muralu'
 * - 'Szerokosc [m]'
 * - 'Wysokosc [m]'
 */
import type { MediaUnitImportAdapter, ValidationError } from './types.js';
import type { MappedRow } from '../validate-row.js';
import {
  buildBaseRow,
  validateRequiredField,
  COMMON_REQUIRED_COLUMNS,
  COMMON_OPTIONAL_COLUMNS,
} from './parse-row.helper.js';

const REQUIRED_COLUMNS = [...COMMON_REQUIRED_COLUMNS, 'Typ nośnika', '[Mural] Element 3D'] as const;

const OPTIONAL_COLUMNS = [
  ...COMMON_OPTIONAL_COLUMNS,
  'Szerokość [m]',
  'Wysokość [m]',
  'Materiał',
  'Oświetlenie',
  '[Mural] Taśma LED',
  '[Mural] Neon LED',
  '[Mural] Fluo UV',
  '[Mural] Produkcja eco muralu',
] as const;

export const muralAdapter: MediaUnitImportAdapter = {
  mediaType: 'mural',
  requiredColumns: REQUIRED_COLUMNS,
  optionalColumns: OPTIONAL_COLUMNS,

  validate(row: MappedRow): ValidationError[] {
    const errors: ValidationError[] = [];
    validateRequiredField(
      errors,
      row['mural_element_3d'],
      'mural_element_3d',
      '[Mural] Element 3D',
    );
    return errors;
  },

  parseRow(row: MappedRow) {
    return buildBaseRow(row, 'mural');
  },
};
